const DEFAULT_MAX_PASTED_CONTENT_LENGTH = 20_000;
const DEFAULT_MAX_TOPIC_LENGTH = 500;
const DEFAULT_UPLOAD_MAX_FILE_BYTES = 10 * 1024 * 1024;

function parsePositiveInt(value, fallback) {
  if (value === undefined || value === null || value === "") {
    return fallback;
  }
  const parsed = Number.parseInt(String(value).trim(), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

function readEnv(...names) {
  if (typeof process === "undefined" || !process.env) {
    return undefined;
  }
  for (const name of names) {
    const value = process.env[name];
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      return value;
    }
  }
  return undefined;
}

/** Max characters for uploaded/pasted document content (align with TEMA_VALIDATION_MAX_PASTED_CONTENT_LENGTH). */
export function getMaxPastedContentLength() {
  return parsePositiveInt(
    readEnv(
      "REACT_APP_TEMA_VALIDATION_MAX_PASTED_CONTENT_LENGTH",
      "TEMA_VALIDATION_MAX_PASTED_CONTENT_LENGTH",
    ),
    DEFAULT_MAX_PASTED_CONTENT_LENGTH,
  );
}

/** Max characters for short topic/concept titles (align with TEMA_VALIDATION_MAX_TOPIC_LENGTH). */
export function getMaxTopicLength() {
  return parsePositiveInt(
    readEnv(
      "REACT_APP_TEMA_VALIDATION_MAX_TOPIC_LENGTH",
      "TEMA_VALIDATION_MAX_TOPIC_LENGTH",
    ),
    DEFAULT_MAX_TOPIC_LENGTH,
  );
}

/** Max upload file size in bytes (align with TEMA_UPLOAD_MAX_FILE_BYTES). */
export function getUploadMaxFileBytes() {
  return parsePositiveInt(
    readEnv("REACT_APP_TEMA_UPLOAD_MAX_FILE_BYTES", "TEMA_UPLOAD_MAX_FILE_BYTES"),
    DEFAULT_UPLOAD_MAX_FILE_BYTES,
  );
}

export {
  DEFAULT_MAX_PASTED_CONTENT_LENGTH,
  DEFAULT_MAX_TOPIC_LENGTH,
  DEFAULT_UPLOAD_MAX_FILE_BYTES,
};
